module.exports = __webpack_public_path__ + "img/double_right_arrows.74067f96.png";